import {SUPPORTED_IMAGES} from '../constants/supportedFiles';

export const isImage = (fileType: string) => {
  return SUPPORTED_IMAGES.split(',').some(s => {
    return fileType.includes(s);
  });
};
